module.exports = "<div class=\"form-box form-response\">\r\n  <div class=\"info-item form-response\">\r\n    <div class=\"info-item-heading\" translate=\"forms.location.verify\"></div>\r\n    <div class=\"form-map\">\r\n    </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/field-templates/location/response-view.html
// module id = 3440
// module chunks = 0